import React from 'react';
import { Button } from '../../../../components';
import DeleteIcon from '@mui/icons-material/Delete';

interface PresentationActionsProps {
  onEdit: () => void;
  onDelete: () => void;
  onView?: () => void;
  loading?: boolean;
}

export const PresentationActions: React.FC<PresentationActionsProps> = ({
  onEdit,
  onDelete,
  onView,
  loading = false,
}) => {
  return (
    <div className="flex items-center justify-end gap-2">
      {onView && (
        <Button
          size="small"
          label="View"
          onClick={onView}
          className="text-blue-600 hover:opacity-70"
        />
      )}
      <Button
        size="small"
        label="Edit"
        onClick={onEdit}
        className="text-blue-600 hover:opacity-70"
      />
      <Button
        onClick={onDelete}
        size="small"
        className="px-2"
        disabled={loading}
        type="contrast"
        icon={<DeleteIcon className="h-8 w-8 text-buttonPrimary" />}
      />
    </div>
  );
};
